// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpDacmyapplyimplIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpDacmyapplyimplIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpDacmyapplyimplIconOutlined = function DrrpDacmyapplyimplIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpDacmyapplyimplIconOutlinedSvg
  }));
};

DrrpDacmyapplyimplIconOutlined.displayName = 'DrrpDacmyapplyimplIconOutlined';
export default React.forwardRef(DrrpDacmyapplyimplIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpDacmyapplyimplIconOutlined.js
// module id = 2509
// module chunks = 0